import { useThemeStore } from '@shared/lib';
import type { Theme } from '@shared/lib';

interface ThemeOption {
  value: Theme;
  label: string;
  icon: string;
  ariaLabel: string;
}

const THEME_OPTIONS: ThemeOption[] = [
  { value: 'light', label: 'Hell', icon: '☀', ariaLabel: 'Helles Theme aktivieren' },
  { value: 'system', label: 'System', icon: '⬛', ariaLabel: 'System-Theme verwenden' },
  { value: 'dark', label: 'Dunkel', icon: '☽', ariaLabel: 'Dunkles Theme aktivieren' },
];

/**
 * Theme-Switcher mit drei Optionen: Hell, System, Dunkel.
 * Verwendet den Zustand Theme Store und ist barrierefrei umgesetzt.
 *
 * @example
 * ```tsx
 * <ThemeSwitcher />
 * ```
 */
export function ThemeSwitcher() {
  const { theme, setTheme } = useThemeStore();

  return (
    <div
      role="group"
      aria-label="Theme auswählen"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '1px',
        background: 'rgba(255,255,255,0.07)',
        borderRadius: '4px',
        padding: '2px',
      }}
    >
      {THEME_OPTIONS.map((opt) => {
        const isActive = theme === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => setTheme(opt.value)}
            aria-label={opt.ariaLabel}
            aria-pressed={isActive}
            title={opt.label}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '28px',
              height: '24px',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer',
              fontSize: '12px',
              lineHeight: 1,
              transition: 'background 0.15s ease, color 0.15s ease',
              background: isActive ? 'rgba(184,78,72,0.85)' : 'transparent',
              color: isActive ? '#ffffff' : 'rgba(255,255,255,0.45)',
            }}
          >
            {opt.icon}
          </button>
        );
      })}
    </div>
  );
}
